"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropLocation } from "@/components/waves/drops/Drop";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import MemesLeaderboardDropCard from "./MemesLeaderboardDropCard";
import MemesLeaderboardDropHeader from "./MemesLeaderboardDropHeader";
import MemesLeaderboardDropDescription from "./MemesLeaderboardDropDescription";
import MemesLeaderboardDropVoteSummary from "./MemesLeaderboardDropVoteSummary";
import MemesLeaderboardDropArtistInfo from "./MemesLeaderboardDropArtistInfo";
import MemeDropTraits from "./MemeDropTraits";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ImageScale } from "@/helpers/image.helpers";
import { useMediaQuery } from "@/hooks/useMediaQuery";
interface MemesLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly location?: DropLocation | undefined;
}
export const MemesLeaderboardDrop: React.FC<MemesLeaderboardDropProps> = t0 => {
  const $ = _c(99);
  const {
    drop,
    onDropClick,
    location: t1
  } = t0;
  const location = t1 === undefined ? DropLocation.WAVE : t1;
  const isMobileScreen = useIsMobileScreen();
  const isTabletOrSmaller = useMediaQuery("(max-width: 1023px)");
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let mediaImageScale = ImageScale.AUTOx800;
  if (isMobileScreen) {
    mediaImageScale = ImageScale.AUTOx450;
  } else {
    if (isTabletOrSmaller) {
      mediaImageScale = ImageScale.AUTOx600;
    }
  }
  let t2;
  if ($[0] !== hasTouchScreen) {
    t2 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t2);
  let t3;
  if ($[2] !== drop.metadata) {
    t3 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[2] = drop.metadata;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const title = t3;
  let t4;
  if ($[4] !== drop.metadata) {
    t4 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[4] = drop.metadata;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const description = t4;
  let t5;
  if ($[6] !== drop.parts) {
    t5 = drop.parts.at(0)?.media.at(0);
    $[6] = drop.parts;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const artworkMedia = t5;
  let t6;
  if ($[8] !== drop.top_raters) {
    t6 = drop.top_raters?.slice(0, 3) ?? [];
    $[8] = drop.top_raters;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const firstThreeVoters = t6;
  let t7;
  if ($[10] !== drop || $[11] !== hasTouchScreen || $[12] !== onDropClick) {
    t7 = () => !hasTouchScreen && onDropClick(drop);
    $[10] = drop;
    $[11] = hasTouchScreen;
    $[12] = onDropClick;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== drop) {
    t8 = <MemesLeaderboardDropArtistInfo drop={drop} />;
    $[14] = drop;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== canDelete || $[17] !== drop || $[18] !== hasTouchScreen) {
    t9 = !hasTouchScreen && <><WaveDropActionsOpen drop={drop} />{canDelete && <WaveDropActionsOptions drop={drop} />}</>;
    $[16] = canDelete;
    $[17] = drop;
    $[18] = hasTouchScreen;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="tw-flex tw-gap-2 tw-text-iron-400">{t9}</div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 tw-pb-3"><div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t8}{t10}</div></div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== title) {
    t12 = <MemesLeaderboardDropHeader title={title} />;
    $[25] = title;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== description) {
    t13 = <MemesLeaderboardDropDescription description={description} />;
    $[27] = description;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="tw-px-4 tw-pb-4 tw-pt-4"><div className="tw-space-y-1">{t12}{t13}</div></div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== artworkMedia || $[33] !== location || $[34] !== mediaImageScale) {
    t15 = artworkMedia && <div className={`tw-flex tw-h-96 tw-justify-center ${location === DropLocation.WAVE ? "tw-bg-iron-950" : "tw-bg-iron-900/40"}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} imageScale={mediaImageScale} /></div>;
    $[32] = artworkMedia;
    $[33] = location;
    $[34] = mediaImageScale;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== drop) {
    t16 = <MemeDropTraits drop={drop} />;
    $[36] = drop;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== drop.context_profile_context || $[39] !== drop.raters_count || $[40] !== drop.rating || $[41] !== drop.rating_prediction || $[42] !== drop.wave.voting_credit_type || $[43] !== firstThreeVoters) {
    t17 = <MemesLeaderboardDropVoteSummary current={drop.rating} projected={drop.rating_prediction} creditType={drop.wave.voting_credit_type} ratersCount={drop.raters_count} topVoters={firstThreeVoters} userContext={drop.context_profile_context} />;
    $[38] = drop.context_profile_context;
    $[39] = drop.raters_count;
    $[40] = drop.rating;
    $[41] = drop.rating_prediction;
    $[42] = drop.wave.voting_credit_type;
    $[43] = firstThreeVoters;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== firstThreeVoters) {
    t18 = firstThreeVoters.map(_temp5);
    $[45] = firstThreeVoters;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t18) {
    t19 = <div className="tw-flex tw-items-center -tw-space-x-2">{t18}</div>;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== drop.raters_count) {
    t20 = formatNumberWithCommas(drop.raters_count);
    $[49] = drop.raters_count;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  const t21 = drop.raters_count === 1 ? "voter" : "voters";
  let t22;
  if ($[51] !== t21) {
    t22 = <span className="tw-font-normal tw-text-iron-500">{t21}</span>;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t20 || $[54] !== t22) {
    t23 = <span className="tw-text-xs tw-font-bold tw-text-white">{t20}{" "}{t22}</span>;
    $[53] = t20;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t19 || $[57] !== t23) {
    t24 = <div className="tw-flex tw-items-center tw-gap-2 @[700px]:tw-hidden">{t19}{t23}</div>;
    $[56] = t19;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setIsVotingModalOpen(true);
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== drop) {
    t26 = <VotingModalButton drop={drop} onClick={t25} />;
    $[60] = drop;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t24 || $[63] !== t26) {
    t27 = <div className="tw-flex tw-w-full tw-flex-shrink-0 tw-items-center tw-justify-between tw-gap-4 @[700px]:tw-w-auto @[700px]:tw-justify-end" onClick={_temp3}>{t24}{t26}</div>;
    $[62] = t24;
    $[63] = t26;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t17 || $[66] !== t27) {
    t28 = <div className="tw-flex tw-flex-col tw-justify-between tw-gap-4 @[700px]:tw-flex-row @[700px]:tw-items-center">{t17}{t27}</div>;
    $[65] = t17;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t16 || $[69] !== t28) {
    t29 = <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4">{t16}{t28}</div>;
    $[68] = t16;
    $[69] = t28;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t11 || $[72] !== t14 || $[73] !== t15 || $[74] !== t29) {
    t30 = <div>{t11}{t14}{t15}{t29}</div>;
    $[71] = t11;
    $[72] = t14;
    $[73] = t15;
    $[74] = t29;
    $[75] = t30;
  } else {
    t30 = $[75];
  }
  let t31;
  if ($[76] !== drop || $[77] !== isMobileScreen || $[78] !== isVotingModalOpen) {
    t31 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[76] = drop;
    $[77] = isMobileScreen;
    $[78] = isVotingModalOpen;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  let t32;
  if ($[80] !== drop || $[81] !== t30 || $[82] !== t31) {
    t32 = <MemesLeaderboardDropCard drop={drop}>{t30}{t31}</MemesLeaderboardDropCard>;
    $[80] = drop;
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== t32 || $[85] !== touchHandlers) {
    t33 = <div {...touchHandlers}>{t32}</div>;
    $[84] = t32;
    $[85] = touchHandlers;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== canDelete || $[88] !== drop || $[89] !== hasTouchScreen || $[90] !== isActive || $[91] !== setIsActive) {
    t34 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[87] = canDelete;
    $[88] = drop;
    $[89] = hasTouchScreen;
    $[90] = isActive;
    $[91] = setIsActive;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  let t35;
  if ($[93] !== t33 || $[94] !== t34) {
    t35 = <div className="tw-group tw-w-full">{t33}{t34}</div>;
    $[93] = t33;
    $[94] = t34;
    $[95] = t35;
  } else {
    t35 = $[95];
  }
  let t36;
  if ($[96] !== t35 || $[97] !== t7) {
    t36 = <div className="tw-w-full tw-cursor-pointer tw-@container" onClick={t7}>{t35}</div>;
    $[96] = t35;
    $[97] = t7;
    $[98] = t36;
  } else {
    t36 = $[98];
  }
  return t36;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(voter) {
  return <Link key={voter.profile.handle} href={`/${voter.profile.handle}`} onClick={_temp4}>{voter.profile.pfp ? <img className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-h-6 tw-w-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link>;
}